import { useCallback, useMemo, useRef } from 'react';
import useMutableValue from '@polestar/component-warehouse-react/hooks/useMutableValue';
export var AccordionControlTypes;
(function (AccordionControlTypes) {
    AccordionControlTypes[AccordionControlTypes["expand"] = 0] = "expand";
    AccordionControlTypes[AccordionControlTypes["close"] = 1] = "close";
    AccordionControlTypes[AccordionControlTypes["toggle"] = 2] = "toggle";
})(AccordionControlTypes || (AccordionControlTypes = {}));
export const useAccordionControls = ({ initialExpanded = {}, closeOthersOnOpen = false, } = {}) => {
    const groupRef = useRef({});
    const currentState = useMutableValue(initialExpanded);
    const handleChange = useCallback((action) => {
        const state = currentState.get();
        let closeGroupId;
        for (const groupId of Object.keys(groupRef.current)) {
            const matchedItem = groupRef.current[groupId].find((result) => result === action.id);
            if (matchedItem) {
                closeGroupId = groupId;
                break;
            }
        }
        const newState = { ...state };
        if (closeOthersOnOpen &&
            // closeGroupId
            closeGroupId &&
            action.type !== AccordionControlTypes.close &&
            !state[action.id]) {
            groupRef.current[closeGroupId].forEach((key) => {
                newState[key] = false;
            });
        }
        const oldValue = state[action.id] || false;
        switch (action.type) {
            case AccordionControlTypes.expand:
                newState[action.id] = true;
                break;
            case AccordionControlTypes.close:
                newState[action.id] = false;
                break;
            default:
                // is when undefined or AccordionControlTypes.toggle:
                newState[action.id] = !oldValue;
                break;
        }
        currentState.set(newState);
    }, [closeOthersOnOpen, currentState]);
    const handleToggle = useCallback((id) => {
        if (id) {
            handleChange({ id, type: AccordionControlTypes.toggle });
        }
    }, [handleChange]);
    const handleExpand = useCallback((id) => {
        if (id) {
            handleChange({ id, type: AccordionControlTypes.expand });
        }
    }, [handleChange]);
    const handleClose = useCallback((id) => {
        if (id) {
            handleChange({ id, type: AccordionControlTypes.close });
        }
    }, [handleChange]);
    const handleIsExpanded = useCallback((id) => {
        return currentState.get()[id];
    }, [currentState]);
    const handleSectionRegister = useCallback((contextId, id) => {
        // collect all section to have the section ids per accordion
        const group = groupRef.current;
        if (!group[contextId]) {
            group[contextId] = [id];
        }
        else {
            group[contextId].push(id);
        }
    }, []);
    const handleSectionUnregister = useCallback((contextId, id) => {
        const group = groupRef.current;
        if (group[contextId]) {
            group[contextId] = group[contextId].filter((item) => item !== id);
        }
    }, []);
    return useMemo(() => ({
        state: currentState,
        expand: handleExpand,
        close: handleClose,
        toggle: handleToggle,
        isExpanded: handleIsExpanded,
        registerSection: handleSectionRegister,
        unregisterSection: handleSectionUnregister,
    }), [
        currentState,
        handleClose,
        handleExpand,
        handleIsExpanded,
        handleSectionRegister,
        handleSectionUnregister,
        handleToggle,
    ]);
};
